import { queryOptions } from '@tanstack/react-query';
import { GetAdjusterRankQueryParamsType } from './getAdjusterRankQuery.type';
import { getAdjusterRankFunction } from './getAdjusterRankQueryFunction';

export const getAdjusterRankQueryOptions = (
  params: GetAdjusterRankQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['AdjusterRank', params],
    queryFn: () => getAdjusterRankFunction(params),
  });
};
